import * as React from "react";
export const StepsContext = React.createContext();

export const UPDATE_FOLIO_STEP = "updateFolioStep";
export const UPDATE_DATOS_CLIENTE_STEP = "updateDatosClienteStep";
export const UPDATE_EMAIL_STEP = "updateEmailStep";
export const RESTART_PROCESS = "restartProcess";

export const useStepsContext = () => React.useContext(StepsContext);

const initialFormState = {
  folioStep: {
    folio: "",
    monto: "",
    origen: ""
  },
  datosClienteStep: {
    personaFisica: true,
    RFC: "",
    usoCFDI: "",
    razonSocial: "",
    codigoPostal: "",
    estado: "",
    ciudad: "",
    colonia: "",
    calle: "",
    numeroExterior: "",
    numeroInterior: "",
    RIF: "",
    idEstado: "",
    idMunicipio: "",
    formaPago: ""
  },
  emailStep: { email: "" },
};

const formReducer = (prevState, action) => {
  switch (action.type) {
    case UPDATE_FOLIO_STEP:
      return {
        ...prevState,
        folioStep: action.props,
      };
    case UPDATE_DATOS_CLIENTE_STEP:
      return {
        ...prevState,
        datosClienteStep: action.props,
      };
    case UPDATE_EMAIL_STEP:
      return {
        ...prevState,
        emailStep: action.props,
      };
    case RESTART_PROCESS:
      return initialFormState;
    default:
      throw new Error(`Unhandled action type: ${action.type}`);
  }
};

function StepsProvider({ children }) {
  const [formStepsState, formStepsController] = React.useReducer(
    formReducer,
    initialFormState
  );

  // NOTE: you *might* need to memoize this value
  // Learn more in http://kcd.im/optimize-context
  const value = {
    formStepsState,
    formStepsController,
  };
  return (
    <StepsContext.Provider value={value}>{children}</StepsContext.Provider>
  );
}

export { StepsProvider };
